import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { ApiService, SupplierEstimateSummary } from "../core/api.service";

@Component({
  selector: "app-dashboard-page",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule],
  templateUrl: "./dashboard-page.component.html",
  styleUrls: ["./dashboard-page.component.scss"],
})
export class DashboardPageComponent {
  private readonly api = inject(ApiService);

  readonly loading = signal(true);
  readonly error = signal<string | null>(null);
  private readonly items = signal<SupplierEstimateSummary[]>([]);

  readonly needsQuote = computed(() =>
    this.items().filter((i) => i.supplierQuoteStatus === "pending"),
  );
  readonly awaitingShop = computed(() =>
    this.items().filter((i) => i.supplierQuoteStatus === "submitted"),
  );
  readonly toShip = computed(() =>
    this.items().filter(
      (i) => i.supplierQuoteStatus === "paid" && !i.trackingNumber,
    ),
  );

  constructor() {
    void this.load();
  }

  async load() {
    this.loading.set(true);
    this.error.set(null);
    try {
      this.items.set(await firstValueFrom(this.api.myEstimates()));
    } catch {
      this.error.set("Failed to load your dashboard. Please try again.");
    } finally {
      this.loading.set(false);
    }
  }

  link(item: SupplierEstimateSummary): unknown[] {
    return item.kind === "diy"
      ? ["/diy-orders", item.orderId]
      : ["/estimates", item.customerId];
  }
}
